import * as React from 'react';
import ProjectLayout from '../ProjectLayout';
import SurveyHeader from '../survey/SurveyHeader';
import { css } from '@emotion/core';
import { onMobileDevice } from '../../globalStyle/mediaQueries';
import { useAppState } from '../../core/redux/hooks';
import { COLORS } from '../../globalStyle/colors';
import LocalHTMLContainer from '../../localization/LocalHTMLContainer';
import { BaseUrl } from '../../core/api/endpoints';
import { pathCombine } from '../../core/api/module';


const styles = {
  content:       css`
    margin-top: 62px;
    background-color: ${COLORS.WHITE};
    padding: 20px;

    ${onMobileDevice} {
      margin-top: 20px;
    }
  `,
  header: css`
    ${onMobileDevice} {
      margin-top: 37px;
    }  
  `,
};

type Props = {
  className?: string;
};


/**
 * CustomResource: a component that renders a Custom Resource
 *
 * PureComponent: true
 * Redux Connected: false
 */
const Resource: React.FC<Props> = props => {
  const id = window.location.href.substring(window.location.href.lastIndexOf('/') + 1);
  const resources = useAppState(state => state.projectResources);
  const resource = resources?.find(r => `${r.nameMessageId}` === id);
  const pageTitle = resource?.nameText;

  const bodyText = () => {
    let text = resource?.bodyText || '';

    const updatedText = () => {
      const baseUrl = BaseUrl.substring(0, BaseUrl.length - 4); // ends with '/api'
      let idx = text.toLowerCase().indexOf('href="developmentplans/');
      while (idx > -1) {
        text = text.substr(0, idx)
          + 'href="'
          + pathCombine(baseUrl, 'DevelopmentPlans/')
          + text.substr(idx + 22);
        idx = text.toLowerCase().indexOf('href="developmentplans/');
      }
      idx = text.toLowerCase().indexOf('href="resources/');
      while (idx > -1) {
        text = text.substr(0, idx)
          + 'href="'
          + pathCombine(baseUrl, 'Resources/')
          + text.substr(idx + 15);
        idx = text.toLowerCase().indexOf('href="resources/');
      }
      return text;
    }
    
    const lcText = text.toLowerCase();

    return lcText.indexOf('href="developmentplans/') === -1 && lcText.indexOf('href="resources/') === -1
      ? text
      : updatedText();
  };

  return (
  <ProjectLayout className={props.className}>
    <SurveyHeader title={`/ ${pageTitle}`} deadline={undefined} css={styles.header} />
    <LocalHTMLContainer
      css={styles.content}
      innerHtml={bodyText()}
    />
  </ProjectLayout>
  )
};

export default Resource;
